import betweenRoundTrophy from '../../assets/tournament/toc/between_round_trophy.png';
import trophy1 from '../../assets/tournament/toc/round_1_trophy.png';
import trophy2 from '../../assets/tournament/toc/round_2_trophy.png';
import trophy3 from '../../assets/tournament/toc/round_3_trophy.png';
import trophy4 from '../../assets/tournament/toc/round_4_trophy.png';
import trophy5 from '../../assets/tournament/toc/round_5_trophy.png';
import startsInTrophy from '../../assets/tournament/toc/starts_in_trophy_v2.png';

/** Trophies 1..5; index by trophy ordinal - 1. */
const TOC_TROPHIES: readonly string[] = [trophy1, trophy2, trophy3, trophy4, trophy5];

/**
 * Per-design mapping from `(totalRounds, roundIndex)` to trophy ordinal.
 * Each row distributes rounds across the 5-trophy ladder so the final round always lands on trophy 5
 * and earlier rounds are spread evenly. Values are 0-based trophy indices into {@link TOC_TROPHIES}.
 */
const TOC_TROPHY_INDEX_BY_ROUND: Record<number, readonly number[]> = {
  2: [2, 4],
  3: [0, 2, 4],
  4: [1, 2, 3, 4],
  5: [0, 1, 2, 3, 4],
};

export const DEFAULT_BETWEEN_ROUND_TROPHY: string = betweenRoundTrophy;
export const DEFAULT_STARTS_IN_TROPHY: string = startsInTrophy;

export const TOC_POLL_INTERVAL_MS = 60_000;
export const TOC_DATA_MAX_AGE_MS = 30_000;

/** Returns the 1-based trophy variant (1..5) for a given round, matching {@link getDefaultTocTrophy}. */
export const getDefaultTocTrophyVariant = (roundIndex: number, totalRounds?: number): number => {
  const mapping = totalRounds != null ? TOC_TROPHY_INDEX_BY_ROUND[totalRounds] : undefined;
  const trophyIdx = mapping?.[roundIndex];
  if (trophyIdx != null && TOC_TROPHIES[trophyIdx]) {
    return trophyIdx + 1;
  }
  return Math.min(roundIndex + 1, TOC_TROPHIES.length);
};

export const getDefaultTocTrophy = (roundIndex: number, totalRounds?: number): string => {
  return TOC_TROPHIES[getDefaultTocTrophyVariant(roundIndex, totalRounds) - 1];
};
